import { FC, useState } from 'react'
import GeneralData from './GeneralData'
import LeaseAdjustments from './LeaseAdjustments'
import {
  ProposalQuoteAdjustments,
  ProposalQuoteOption,
  ProposalReviewView,
} from '@/types/management.types'
import VehicleData from './VehicleData'

interface Props {
  proposal: ProposalQuoteOption | null
  setView?: (view: ProposalReviewView) => void
}

const ProposalAdjustmentsContent: FC<Props> = ({ proposal, setView }) => {
  const [proposalData, setProposalData] = useState<ProposalQuoteOption | null>(
    proposal
  )

  const { proposalGeneralInfo, vehicleData, adjustments, conditions } =
    proposalData || {}

  const handleCancel = () => {
    console.log('User cancelled')
    setView?.('rejected')
    // Navigate back or reset form
  }

  const handleAdjustmentsChange = (adjustments: ProposalQuoteAdjustments) => {
    setProposalData(prev =>
      prev
        ? {
            ...prev,
            adjustments,
          }
        : null
    )
  }

  const handleOnConfirm = () => {
    console.log('User confirmed')
    // Proceed with the confirmed proposal
    setView?.('new')
  }

  if (!proposalData) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg text-gray-600">Cargando propuesta...</div>
      </div>
    )
  }

  return (
    <div className="w-full max-w-6xl p-8 items-center">
      <div className="px-8 rounded-lg max-w-3xl w-full mx-auto">
        <h2 className="text-2xl font-bold text-gray-900 mb-2 text-center">
          Tu cotización está lista
        </h2>

        <p className="text-gray-900  mb-8 justify-center text-center wordwrap">
          Hemos revisado tu información y generado una propuesta con las
          condiciones de arrendamiento. Por favor, revísala cuidadosamente y
          elige cómo deseas continuar.
        </p>
      </div>

      <GeneralData generalInfo={proposalGeneralInfo} />

      <h2 className="text-xl font-bold text-gray-900 mb-2 text-left">
        Cotización
      </h2>

      <VehicleData generalInfo={vehicleData} />
      <LeaseAdjustments
        adjustments={adjustments}
        conditions={conditions}
        onAdjustmentsChange={handleAdjustmentsChange}
        onConfirm={handleOnConfirm}
        onCancel={handleCancel}
      />
    </div>
  )
}

export default ProposalAdjustmentsContent
